  <template>
  <div>
    <van-nav-bar
      :title="$t('app.platformtransfer.transfer_details')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/platform_transfer')"

    />
    <div class="">
      <van-row style="padding-top: 10px;"
        ><van-col span="3" class="rowStyle" style="text-align: center"
          ><span style="font-size: 13px">{{ $t('app.timebao_detail.date') }}</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                style="color: red"
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                :title=" $t('app.timebao_detail.selectDate') "
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="2" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                :title="$t('app.timebao_detail.selectDate')"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            type="danger"
            size="small"
            style="height: 30px; background-color: unset; color: #0D268D"
            @click="onSearchButton"
            >{{ $t('app.timebao_detail.search') }}</van-button
          ></van-col
        >
      </van-row>
    </div>

    <!-- TABLE SECTION -->
    <div id="platformTransferLog" class="tableContent">

      <!-- HEADER TABLE -->
      <div class="tableheading">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>{{ $t('app.platformtransfer.order_number') }}</th>
            <th>{{ $t('app.platformtransfer.central_system_number') }}</th>
            <th>{{ $t('app.platformtransfer.transfer_amount') }}</th>
            <th>{{ $t('app.platformtransfer.account_balance') }}</th>
            <th>{{ $t('app.platformtransfer.transfer_operation_type') }}</th>
            <th>{{ $t('app.friend_coupon.status') }}</th>
            <th>{{ $t('app.platformtransfer.accessed_platform') }}</th>
            <th>{{ $t('app.platformtransfer.create_time') }}</th>
          </tr>
        </table>
      </div>
      <div class="tabledata">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('app.common.finished')"
          @load="loadMore"
        >
          <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
            <tr
              class="stock_td"
              v-for="(item, index) in platfromTransferDetails"
              :key="index"
            >
              <td>
                <p>
                  <span>{{ item.order }}</span>
                </p>
              </td>
              <td>
                <p>
                  <span>{{ item.reference_number }}</span>
                </p>
              </td>
              <td>
                <p>
                  <span>{{ item.number }}</span>
                </p>
              </td>
              <td>
                <p>
                  <span>{{ item.balance }}</span>
                </p>
              </td>
              <td>
                <p :style="item.type === '转入'||item.type === 'Transfer In' ? 'color:#3f7a21' : item.type === '转出'||item.type === 'Transfer Out' ? 'color:#D02E27' : 'color:#0D268D'">
                  {{ item.type }}
                </p>
              </td>
              <td>
                <p :style="item.status === '成功'||item.status === 'Success' ? 'color:#3f7a21' : item.status === '失败'||item.status === 'Fail' ? 'color:#D02E27' : 'color:#0D268D'">
                  {{ item.status }}
                </p>
              </td>
              <td>
                <p>{{ item.request_platform }}</p>
              </td>
              <td>
                <p>{{ item.time }}</p>
              </td>
            </tr>
          </table>
          
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "PlatformTransferLog",
  data() {
  return {
      date: new Date(),
      isLoading: false,
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
      platfromTransferDetails: [],
      finished: false,
      loading: false,  
      page: 0,
      num: 20,
    };
  },
  computed: {},
  methods: {
    onSearchButton() {
      this.page = 0;
      this.platfromTransferDetails = [];
      this.finished = false;
      this.loadMore();      
    },
      loadMore() {
      // if (this.loading) return;  
      this.loading = true;
      this.page++;
      this.getDetails();
    },
    onRefresh() {
      this.platfromTransferDetails = [];
      this.finished = false;
      this.page=0;
      this.refreshing = true;
      this.getDetails();
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
    getDetails() {
    let that = this;
    that
      .$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "platform_transfer",
          token: sessionStorage.getItem("token"),
          action: "transaction_log",
          start: that.startDate,
          end: that.endDate,
          page: that.page,
          num: that.num,
        },
      })
      .then(function (res) {
        if (res.data.code == 1) {
          let resData = res.data;
          if (resData.data.length === 0) {
            that.finished = true;
          } else {
            resData.data.forEach((element) => {
              that.platfromTransferDetails.push(element);
            });
            if (resData.data.length < that.num) {
              that.finished = true;
            }
          }
          that.loading = false;
          that.isLoading = false;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(res.data.msg);
          that.loading = false;
          that.isLoading = false;
        }
      })
      .catch(() => {
        that.loading = false;
        that.isLoading = false;
        that.finished = true;
      });
  },

  },
  mounted() {
    this.page = 0;
    this.loadMore();
  },

};
</script>

<style scoped>
/* Basic styles */
.rowStyle { height: 30px; line-height: 30px; }
.calanderStyle { border: 1px solid #969799; }
.rowStyleBtn { line-height: 20px; }

/* Main table wrapper */
#platformTransferLog {
  overflow-x: auto;
  width: 100vw;
  padding-top: 20px;
}

/* Both header + body tables */
#platformTransferLog .stockTable {
  table-layout: fixed;
  width: 1080px;
  border-collapse: collapse;
}

#platformTransferLog .stockTable th,
#platformTransferLog .stockTable td {
  text-align: center;
  padding: 5px 5px;
  border-bottom: 1px solid #ebedf0;
  white-space: nowrap;
}

/* COLUMN WIDTHS */
#platformTransferLog .stockTable th:nth-child(1),
#platformTransferLog .stockTable td:nth-child(1) { width: 140px; }

#platformTransferLog .stockTable th:nth-child(2),
#platformTransferLog .stockTable td:nth-child(2) { width: 160px; }

#platformTransferLog .stockTable th:nth-child(3),
#platformTransferLog .stockTable td:nth-child(3) { width: 120px; }

#platformTransferLog .stockTable th:nth-child(4),
#platformTransferLog .stockTable td:nth-child(4) { width: 120px; }

#platformTransferLog .stockTable th:nth-child(5),
#platformTransferLog .stockTable td:nth-child(5) { width: 130px; }

#platformTransferLog .stockTable th:nth-child(6),
#platformTransferLog .stockTable td:nth-child(6) { width: 100px; }

#platformTransferLog .stockTable th:nth-child(7),
#platformTransferLog .stockTable td:nth-child(7) { width: 130px; }

#platformTransferLog .stockTable th:nth-child(8),
#platformTransferLog .stockTable td:nth-child(8) { width: 180px; }

/* Header */
.tableheading {
  font-size: 14px;
  padding-bottom: 10px;
}

.tabledata {
  font-size: 14px;
  /* margin-top: 145px; */
}
</style>



// WEBPACK FOOTER //
// src/components/PlatformTransferLog.vue